import React from 'react';
import { connect } from 'react-redux';
import { RouteComponentProps } from 'react-router';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faAngleDown, faAngleUp } from '@fortawesome/free-solid-svg-icons'
import { RootState, actions } from '../store';
import {
  IonPage, IonItem, IonCardContent, IonCard, IonCardSubtitle,
  IonBackButton, IonButtons, IonContent, IonHeader, IonTitle, IonToolbar,
} from '@ionic/react';
import OperatingHours from '../components/OperatingHours';
import Contacts from '../components/Contacts';
import Address from '../components/Address';
import Direction from '../components/Direction';
// import Map from '../components/CampMap';

const MarkerClusterer = require('node-js-marker-clusterer');

type Props = RouteComponentProps<{ id: string, tab: string }> & typeof mapDispatchToProps & ReturnType<typeof mapStateToProps> & {
  goBack: () => void
};

type State = {
  list: any,
};

class VisitorCenterDetails extends React.Component<Props, State> {
  mapEle: any;
  map?: any;
  markers: any[];
  defaultState: State = {
    list: {},
  };

  constructor(props: Props) {
    super(props);
    this.state = {
      ...this.defaultState
    };
    this.mapEle = React.createRef();
    this.markers = [];
  }

  componentWillMount = async () => {
    const {
      match,
    } = this.props;
    await this.props.getVisitorCentersByCode(match.params.id);
  }

  componentDidMount() {
    const { parkMap, loadedVisitorCenters, match } = this.props;
    const lat = parkMap[match.params.id] && parkMap[match.params.id].lat;
    const lng = parkMap[match.params.id] && parkMap[match.params.id].lng;
    if (!lat || !lng) {
      return;
    }
    const visitorCenters = loadedVisitorCenters[match.params.id];
    this.map = new google.maps.Map(this.mapEle.current, {
      center: { lat, lng },
      zoom: 7
    });
    const list = {};
    visitorCenters.forEach((item: any, index: number) => {
      const {  latLong, name } = item;
      list[index] = false;
      if (!latLong) {
        return;
      }
      let latLong2 = latLong.substring(1, latLong.length - 1).split(',');
      const lat = Number(latLong2[0].split(':')[1]);
      const lng = Number(latLong2[1].split(':')[1]);
      let infoWindow = new google.maps.InfoWindow({
        content: `${name}`
      });
      let marker = new google.maps.Marker({
        position: {
          lat,
          lng,
        },
        map: this.map,
        title: JSON.stringify(item.name),
        icon: '/assets/img/info.png'
      });

      marker.addListener('click', () => {
        infoWindow.open(this.map, marker);
        // this.setShowPopover(true);
        // this.setState({
        //   ...this.state,
        //   data: marker.getTitle() || '{}',
        // });
      });
      this.markers.push(marker);
    });
    this.setState({
      ...this.state,
      list,
    });
    var markerCluster = new MarkerClusterer( // eslint-disable-line
      this.map,
      this.markers,
      { imagePath: 'https://developers.google.com/maps/documentation/javascript/examples/markerclusterer/m' },
    );
    // zoom and center the map around the markers
    if (this.map && this.markers.length) {
      const bounds = new google.maps.LatLngBounds();
      for (let i = 0; i < this.markers.length; i++) {
        bounds.extend(this.markers[i].getPosition());
      }
      // this.map.fitBounds(bounds);
      this.map.getCenter();
    }
    try {
      let adsbygoogle;
      // @ts-ignore
      (adsbygoogle = window.adsbygoogle || []).push({});
    } catch (e) {}
  }

  handleAccordion(index: number) {
    const list = {};
    Object.keys(this.state.list).forEach((item) => {
      list[item] = false;
    });
    this.setState({
      ...this.state,
      list: {
        ...list,
        [index]: !this.state.list[index],
      },
    });
  }

  render() {
    const { match, loadedVisitorCenters, parkMap } = this.props;
    const parkCode = match.params.id;
    const parkName = parkMap[parkCode] && parkMap[parkCode].name;
    const visitorCenters = loadedVisitorCenters[parkCode];
    const UNKNOWN = '???';
    return (
      <IonPage className="campground-details">
        <IonHeader>
          <IonToolbar>
            <IonButtons slot="start">
              <IonBackButton defaultHref={match.url.replace('/visitorcenters', '')} />
            </IonButtons>
            <IonTitle>{parkName} Visitor Centers</IonTitle>
          </IonToolbar>
        </IonHeader>
        <IonContent>
          <IonCard>
          { visitorCenters && visitorCenters.map((item: any, index: number) => {
            let phone;
            let email;
            if (item.contacts) {
              phone = item.contacts.phoneNumbers;
              email = item.contacts.emailAddresses;
            }
            let address;
            if (item.addresses) {
              address = item.addresses;
            }
            return (
              <IonItem key={`visitor-center-${index}`} onClick={() => { this.handleAccordion(index) } }>
                <IonCardContent key={'visitor-center'+index} className="width100" >
                  <IonCardSubtitle className="width100" >
                    {item.name}
                    <FontAwesomeIcon className="floatRight" icon={this.state.list[index] ? faAngleUp : faAngleDown} />
                  </IonCardSubtitle>
                  <div></div>
                  <div className={this.state.list[index] ? 'noLeftPadding grayBg slider' : 'slider closed' }>
                    <IonCardContent>
                      <div>{item.description}</div>
                    </IonCardContent>
                    <IonCardContent>
                      <div>Location: {item.latLong ? 'See map below' : 'Not Available' }</div>
                    </IonCardContent>
                    
                    <OperatingHours title="Operating Hours" hours={item.operatingHours} />
                    <Contacts title="Contacts" phones={phone} emails={email} />

                    <Address addresses={address} title="Address" />
                    <Direction url={item.Url} info={item.directionsInfo} title="Directions" />
                    <IonCardContent>
                      <div>More info</div>
                      <a href={item.url}>{item.url}</a>
                    </IonCardContent>
                    
                  </div>
                </IonCardContent>
              </IonItem>
            )
          })}
            <IonCardContent>
              <div style={{position: 'relative'}}>
                <div ref={this.mapEle} style={{height: '400px', width: '100%'}} id="location-map"></div>
              </div>
            </IonCardContent>
            <ins className="adsbygoogle"
            style={{display:'block'}}
            data-ad-client="ca-pub-2796376641761374"
            data-ad-slot="1578893839"
            data-ad-format="auto"
            data-full-width-responsive="true"></ins>
          </IonCard>
        </IonContent>
      </IonPage>
    );
  }
  
}

const mapDispatchToProps = {
  getVisitorCentersByCode: (parkCode: string) => actions.visitorCenters.getVisitorCenters(parkCode),
}

const mapStateToProps = (state: RootState) => ({
  parkMap: state.places.parkMap,
  loadedVisitorCenters: state.visitorCenters.loadedVisitorCenters,
  parkName: state.visitorCenters.parkName,
  parkCode: state.visitorCenters.parkCode,
  latLong: state.visitorCenters.latLong,
});

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(VisitorCenterDetails)
